import { render } from "./ProjectsAccountInfoCard.vue?vue&type=template&id=82b11b5e"
import script from "./ProjectsAccountInfoCard.vue?vue&type=script&lang=js"
export * from "./ProjectsAccountInfoCard.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__